import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { PageHero } from "../components/common/PageHero";
import { ProductCard } from "../components/common/ProductCard";
import { EmailCapture } from "../components/common/EmailCapture";
import { ProductInterest } from "../components/home/ProductInterest";
import { Reveal } from "../components/common/Reveal";
import { api } from "../lib/api";

const FILTERS = [
    { label: "All", value: "all" },
    { label: "Cotton Candy", value: "cotton_candy" },
    { label: "Popcorn", value: "popcorn" },
    { label: "Party Packs", value: "Party Packs" },
    { label: "Mystery", value: "Mystery" },
];

export const ShopPage = () => {
    const [products, setProducts] = useState([]);
    const [params, setParams] = useSearchParams();
    const active = params.get("kind") || params.get("category") || "all";

    useEffect(() => {
        document.title = "Shop The Fun — Showtime Carnival Co. | Cotton Candy & Popcorn NYC";
        api.get("/products")
            .then((res) => setProducts(res.data || []))
            .catch(() => {});
    }, []);

    const visible = products.filter((p) => {
        if (active === "all") return true;
        if (active === "cotton_candy" || active === "popcorn") return p.kind === active && p.category !== "Party Packs";
        return p.category === active;
    });

    return (
        <>
            <PageHero
                kicker="The Goods."
                title="Packaged Showtime Is Coming."
                copy="Fresh-spun cotton candy, gourmet popcorn, party packs and Mystery Flavors are getting ready for the spotlight."
                dark={false}
                testid="shop-hero"
            />
            <section className="bg-white py-16 md:py-24">
                <div className="mx-auto max-w-[1440px] px-5 md:px-10">
                    <Reveal>
                        <div className="flex flex-wrap gap-2 mb-12" data-testid="shop-filters">
                            {FILTERS.map((f) => (
                                <button
                                    key={f.value}
                                    onClick={() => setParams(f.value === "all" ? {} : { kind: f.value })}
                                    data-testid={`shop-filter-${f.label.toLowerCase().replace(/\s+/g, "-")}`}
                                    className={`rounded-full px-5 py-2.5 font-oswald uppercase tracking-widest text-xs transition-colors duration-300 active:scale-95 ${
                                        active === f.value
                                            ? "bg-ink text-white"
                                            : "border border-zinc-300 text-zinc-600 hover:border-pink hover:text-pink-dark"
                                    }`}
                                >
                                    {f.label}
                                </button>
                            ))}
                        </div>
                    </Reveal>
                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-testid="shop-grid">
                        {visible.map((p, i) => (
                            <ProductCard key={p.id} product={p} index={i} />
                        ))}
                    </div>
                    {visible.length === 0 && (
                        <div className="rounded-3xl border border-dashed border-zinc-300 p-12 text-center" data-testid="shop-coming-soon">
                            <p className="font-oswald uppercase text-3xl md:text-4xl text-ink">Packaged Showtime Is Coming.</p>
                            <p className="text-sm md:text-base text-zinc-500 mt-3 max-w-md mx-auto">
                                Cotton candy, popcorn, Mystery Flavors and party-ready packs are getting ready for the spotlight.
                            </p>
                            <div className="mt-8 flex justify-center">
                                <EmailCapture source="shop_coming_soon" testid="shop-notify" />
                            </div>
                        </div>
                    )}
                    <ProductInterest source="Shop" testerCopy="Help us put upcoming Showtime flavors to the test." />
                </div>
            </section>
        </>
    );
};
